export const NavbarSkeleton = () => <div className="h-14 w-full animate-pulse border-b bg-muted" />
